// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class socialClubAPI extends MainAPI {
	/**
	 * @return {object} list of members
	 * @params productType
	 * */
	async getGroupMembers(queryParams) {
		return API.get(`${ENDPOINTS.GET_GROUPS}/member?${queryString.stringify(queryParams)}`);
	}

	/**
	 * @return {object} list of clubs
	 * @params queryParams
	 * */
	async getGroups(queryParams) {
		return API.get(`${ENDPOINTS.GET_GROUPS}?${queryString.stringify(queryParams)}`);
	}

	/**
	 * @return {object} admin tab reported table list
	 * @param {*} breedId
	 * @param {*} reportedDetails
	 */
	async getAdminReported(breedId, reportedDetails) {
		return API.get(`${ENDPOINTS.GET_ADMIN_REPORTED}/${breedId}?${queryString.stringify(reportedDetails)}`);
	}

	/**
	 * @param {Number} breedId
	 * @param {Number} reportId
	 * @param {String} type - Can be approve or disapprove
	 * */
	async putActionReportedContent(groupId, reqBody) {
		return API.put(`${ENDPOINTS.PUT_REPORT_CONTENT}/${groupId}/update-report-status`,reqBody);
	}

	/**
	 * @param {Number} breedId
	 * @param {Number} customerId
	 * */
	async putMakeAdmin(breedId, customerId) {
		return API.put(`${ENDPOINTS.PUT_CLUB}/${breedId}/make-admin/${customerId}`);
	}

	/**
	 * @param {Number} breedId
	 * @param {Number} customerId
	 * */
	async putRemoveAdmin(breedId, customerId) {
		return API.put(`${ENDPOINTS.PUT_CLUB}/${breedId}/remove-admin/${customerId}`);
	}
}

export default new socialClubAPI();
